import styled, { keyframes } from 'styled-components';

const listItemBorderColFlash = keyframes`
    50% {
        border-color: #00B860;
        box-shadow: 0 0 15px #00B860;
    }
`;

const listItemFadeOut = keyframes`
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`;

const listItemFadeIn = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

const ListItemTile = styled.div`
    border: 1px solid ${props => props.theme.colors.darkgray};
    margin-top: 20px;
    transition: all .5s;
    padding: 10px;

    :hover {
         box-shadow: 0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23);
         border-color: #007DC6;
    }

    &.new {
        animation: ${listItemFadeIn} 1s linear 0s 1 normal none, ${listItemBorderColFlash} 1.5s linear 0s 1 normal none;
    }

    &.fadingOut {
        animation: ${listItemFadeOut} .5s linear 0s 1 normal forwards;
    }
`;

export default ListItemTile;



// WEBPACK FOOTER //
// ./src/components/atoms/layout/ListItemTile.js